import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { CaseMultipleChoiceCardWrapper } from '@seedlang/hoc';
import { DeckUI } from '@seedlang/state';
import { flexCenterColumn } from '@seedlang/style_mixins';
import CardText from 'components/card/card_text';
import EvaluateButtons from 'components/card/evaluate_buttons';
import MultipleChoiceButtons from 'components/card/multiple_choice_buttons';
import CardContent from 'components/layout/card_content';
import CardWrapper from 'components/layout/card_wrapper';
import Text from 'components/text';
import CardSection from 'components/vocab_card/card_section';
import MediaSection from 'components/vocab_card/media_section';
import CardArrowBox from 'components/card/card_arrow_box';
import { observer } from 'mobx-react';
import React from 'react';

const SentenceWrapper = styled.div`
  ${flexCenterColumn()}
  flex: 1;
  width: 100%;
  height: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: ${Theme.z['card-4']};
  .fa-check {
    color: ${Theme.green};
  }
  .fa-times {
    color: ${Theme.red};
  }
`;

const Feedback = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const CaseLabel = styled.span`
  background: ${props => props.background};
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: bold;
`;

@observer
class CaseMultipleChoiceCard extends React.Component {

  render() {
    const numSections = 2;
    const sectionHeight = this.props.cardState.revealed ?
      DeckUI.layout.heightForCardSections(numSections, 0, false) :
      DeckUI.layout.heightForCardSections(numSections, 0, true);

    return (
      <CardWrapper
        card={this.props.card}
        cardState={this.props.cardState}
        userCard={this.props.userCard}
        icons={this.props.icons}
      >
        <CardContent
          height={this.props.cardState.revealed ?
            DeckUI.layout.contentHeight :
            DeckUI.layout.contentHeightWithMultipleChoiceButtons(4)
          }
        >
          <MediaSection
            showMedia
            autoPlay={this.props.inView}
            card={this.props.card}
            cardState={this.props.cardState}
            height={sectionHeight}
            borderTopRadius={10}
          />
          <CardSection
            numSections={numSections}
            padding='20px'
            background='#f5f5f5'
            borderBottomRadius={10}
            height={sectionHeight}
          >
            <CardArrowBox
              card={this.props.card}
              possibleArrowBoxes={this.props.possibleArrowBoxes}
              currentArrowBox={this.props.currentArrowBox}
            />
            {
              this.props.cardState.revealed &&
                <IconWrapper>
                  {
                    this.props.userCard.correct &&
                      <i className='fa fa-check' />
                  }
                  {
                    !this.props.userCard.correct &&
                      <i className='fa fa-times' />
                  }
                </IconWrapper>
            }
            <SentenceWrapper>
              <CardText
                card={this.props.card}
                cardState={this.props.cardState}
                sentence={this.props.card.sentence}
                showText
                showSentenceBreakdown
                showType={this.props.cardState.showType}
                height={this.props.cardState.revealed ? sectionHeight - 80 : sectionHeight - 20}
                background='#f5f5f5'
                sourceText={this.props.card.sentence?.sourceTextForUser(DeckUI.user)}
                highlightWordAssociationIds={this.props.card.nounPhraseWordAssociationIds}
                highlightType='background'
                showCase={this.props.cardState.revealed}
                prompt={this.props.cardState.revealed ? null : this.props.prompt}
                disableOnClick={!this.props.cardState.revealed}
                showUnderline={this.props.cardState.revealed}
                hideHighlight={false}
                grammarHint={this.props.grammarHint}
                showSpinner
              />
              {
                this.props.cardState.revealed &&
                  <Feedback>
                    <Text bold color={this.props.userCard.correct ? Theme.green : Theme.red}>
                      {this.props.currentMessage.prefix}
                      <CaseLabel background={this.props.correctAnswerBackgroundColor}>
                        {this.props.currentMessage.caseName}
                      </CaseLabel>
                    </Text>
                  </Feedback>
              }
            </SentenceWrapper>
          </CardSection>
        </CardContent>
        {
          !this.props.cardState.revealed &&
            <MultipleChoiceButtons
              options={this.props.caseOptions}
              selected={this.props.selectedCase ? [this.props.selectedCase] : []}
              onClick={this.props.onSelectCase}
              disabled={this.props.cardState.revealed}
              field='label'
              languageId='DE'
              revealed={this.props.cardState.revealed}
              correct={this.props.userCard.correct}
              width={DeckUI.layout.innerDeckWidth}
              height={DeckUI.layout.totalMultipleChoiceButtonHeight(4)}
              buttonHeight={DeckUI.layout.multipleChoiceButtonHeight}
              fontSize='16px'
              isMobile={DeckUI.layout.isMobile}
            />
        }
        {
          this.props.cardState.revealed &&
            <EvaluateButtons
              card={this.props.card}
              cardState={this.props.cardState}
              userCard={this.props.userCard}
              disabled={!this.props.inView}
              onNextClick={this.props.onNextClick}
              onCheckAnswer={this.props.onCheckAnswer}
            />
        }
      </CardWrapper>
    );
  }
}

export default CaseMultipleChoiceCardWrapper(CaseMultipleChoiceCard);